import script from "./PlatformAdminLoginView.vue?vue&type=script&lang=ts&setup=true"
export * from "./PlatformAdminLoginView.vue?vue&type=script&lang=ts&setup=true"

import "./PlatformAdminLoginView.vue?vue&type=style&index=0&id=6a209e15&lang=scss"

const __exports__ = script;

export default __exports__